import type { UploadedResource } from "../media/uploadedResources"

const homePromptTransferKey = "home-prompt-transfer"

export type HomePromptTransferPayload = {
  prompt: string
  duration?: number
  model?: API.Task.CreateVideoChannel
  references?: UploadedResource[]
  ratio?: API.VideoRatio
  resolution?: API.VideoResolution
}

const normalizeHomePromptTransferPayload = (
  payload: HomePromptTransferPayload | string,
): HomePromptTransferPayload => {
  if (typeof payload === "string") {
    return {
      prompt: payload,
    }
  }

  return payload
}

const parseHomePromptTransferPayload = (value: string) => {
  try {
    const payload = JSON.parse(value) as Partial<HomePromptTransferPayload>

    if (typeof payload.prompt !== "string") {
      return {
        prompt: value,
      }
    }

    return {
      duration:
        typeof payload.duration === "number" ? payload.duration : undefined,
      model: payload.model,
      prompt: payload.prompt,
      references: Array.isArray(payload.references) ? payload.references : [],
      ratio: typeof payload.ratio === "string" ? payload.ratio : undefined,
      resolution:
        typeof payload.resolution === "string" ? payload.resolution : undefined,
    } satisfies HomePromptTransferPayload
  } catch {
    return {
      prompt: value,
    }
  }
}

export const saveHomePromptTransfer = (
  payload: HomePromptTransferPayload | string,
) => {
  const transferValue = JSON.stringify(
    normalizeHomePromptTransferPayload(payload),
  )

  window.localStorage.setItem(homePromptTransferKey, transferValue)
}

export const readHomePromptTransfer = () => {
  const value = window.localStorage.getItem(homePromptTransferKey)

  if (!value) return null

  return parseHomePromptTransferPayload(value)
}

export const clearHomePromptTransfer = () => {
  window.localStorage.removeItem(homePromptTransferKey)
}
